<template>
<div id="headers">
<div class="s1" id="s1"><img src="../assets/xiaochengxu.jpg"></div>
<div style="position:fixed;right:0px;top:250px;font-size:14px;" v-if="userinfo.level==2">
<router-link to="/cart" ><div>购物车</div>
<div class="badge" id="box" style="background:#c9302c">
{{cart_num}}
</div>
 </router-link>
</div>

<div class="wrap" style="width:1424px">
                        <div class="front-header-in">

                            <div class="front-logo">
                                <a href="/" class="logo-link"></a>
                            </div>
                            <div class="top-login" v-if="username">
                             <a href="#"  v-on:mouseover="show()"  v-on:mouseout="dis()" >小程序二维码</a> <b>|</b>
                              用户名<span style="color:black;font-weight:bold">{{username}}</span> <b>|</b> 
                                            <a href="javascript:void(0);" v-on:click="logout()">退出</a>
                             
                            </div>
                            <div class="top-login" v-else>
                            <a href="#"  v-on:mouseover="show()"  v-on:mouseout="dis()" >小程序二维码</a>  <b>|</b>
                               <a href="/login/">登录</a> <b>|</b> 
                              <a href="/reg/">注册</a> 
                                                        
                            </div>
                             <div style="font-size:20px;text-align:right;float:right;padding-top:65px;color:#737373;display:inline-block;">钻石现货供应平台</div>
                          </div>
                   </div>

<div class="front-navs">
                    <div class="wrap">
                        <ul>
                            <li> <router-link  to="/" >首页</router-link></li>
                             <li><router-link to="/search" >裸钻搜索</router-link></li>
                            <li><router-link to="/vi" >天然钻石</router-link></li>
                            <li><router-link to="/mitation" >培育钻石</router-link></li>
                            <li><router-link to="/colored" >培育彩钻</router-link></li>
                            <li ><router-link to="/price"  v-if="userinfo.level==2">国际报价</router-link></li>
                            <li><router-link to="/query">证书查询</router-link></li>
                            <li><router-link to="/contact"  >联系我们</router-link></li>
            <li> <router-link to="/order" v-if="userinfo.level==2">我的订单</router-link></li>
              <li> <router-link to="/download" v-if="userinfo.download==1">库存下载</router-link></li>
                        </ul>
                    </div>
 </div>



</div>
</template>

<script>
import Bus from './bus.js'



export default {
  name: 'Headers',
  data(){
  return {
  username:localStorage.username,
  cart_num:0,
  userinfo:{'level':0,'download':0},
  wap:false
  }
  },

  mounted: function () {
      var vm = this
      
      // 用$on事件来接收参数
      Bus.$on('val', (data) => {
        console.log(data)
        vm.cart_num = data
      })
    },
  methods: {

     getCartNum: function () {
          this.$http.post('https://www.giazh.com/auth/cart/cartnum',{},{ headers: {'Authorization': localStorage.authorization},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	    this.cart_num=data.body;
	   
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				//alert('已退出');
				//window.location.reload(true);
			      });
    },
     getUserInfo: function () {
          this.$http.post('https://www.giazh.com/auth/user/userinfo',{},{ headers: {'Authorization': localStorage.authorization},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	    this.userinfo=data.body;
	   
	    }).catch(err => {
				console.log(err);
				localStorage.clear();
				alert('已退出');
				window.location.reload(true);
			      });
    },
     logout: function () {
        var url="https://www.giazh.com/auth/logout";
	 let token = localStorage.authorization;
	 if(token){
	  this.$http.post(url,{},{ headers: {'Authorization': token},emulateJSON:true}).then(successResponse => {
						if (successResponse.body.status === "success") {
							console.log(successResponse);
							localStorage.clear();
							alert(successResponse.body.msg);
							this.$router.push('/login');
							
						}
					})

					}
                          }

           ,
           show: function(){
document.getElementById("s1").style.display="block";
},
dis: function (){
document.getElementById("s1").style.display="none";
}     

    },
  created(){
 let token = localStorage.authorization;
 if(token){ 
          this.getCartNum();
	  this.getUserInfo();
          }
  }
}
</script>

<style>
.s1{
position: absolute;
top:50px;
right:50px;
z-index:1;
display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Headers.vue